import { themeColors } from '@/theme/colors';
import type { CSSProperties } from 'react';

type SummaryTableHeaderProps = {
  text: string;
  style?: CSSProperties;
};

const SummaryTableHeader = ({ text, style }: SummaryTableHeaderProps) => {
  return (
    <span
      className="body-md-medium"
      style={{
        borderBottom: `1px solid ${themeColors.stroke.default}`,
        height: '48px',
        display: 'flex',
        alignItems: 'center',
        padding: '8px',
        ...style,
      }}
    >
      {text}
    </span>
  );
};
export default SummaryTableHeader;
